document.addEventListener("DOMContentLoaded", () => {
    const modal = document.getElementById('deleteAccountModal');
    const deleteButton = document.getElementById("deleteConfirmButton");

    if (modal) {

        const deleteConfirmButton = document.getElementById("deleteConfirmButton");
        deleteConfirmButton.disabled = true;

        const confirmationCheckbox = document.getElementById("confirmationCheckbox");
        confirmationCheckbox.checked = false;

        const passwordInput = document.getElementById("accountPassword");
        passwordInput.value = "";
    }

    let checkBox = document.getElementById("confirmationCheckbox");

    if (checkBox) {
        checkBox.addEventListener("change", function () {
            const deleteConfirmButton = document.getElementById("deleteConfirmButton");
            deleteConfirmButton.disabled = !this.checked;

            const passwordInput = document.getElementById("accountPassword");

            if (this.checked) {
                passwordInput.removeAttribute("disabled");
            } else {
                passwordInput.setAttribute("disabled", "true");
            }
        });
    }

    if (deleteButton) {
        deleteButton.addEventListener("click", async (event) => {
            try {
                event.preventDefault();
                deleteButton.innerHTML = `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Deleting...`;
                await devtricker_confirmAccountDelete();
            } catch (error) {
                deleteButton.innerHTML = `Delete`;
                console.error(error.message)
            }
        });
    }


});

async function devtricker_confirmAccountDelete() {
    const password = document.getElementById("accountPassword").value;
    const deleteButton = document.getElementById("deleteConfirmButton");

    if (!password) {
        alert('Please enter your password to confirm account deletion.');
        return;
    }

    try {
        const deletionResult = await devtricker_ajax_deleteAccount(password);
        if (deletionResult) {
            alert('Your account has been successfully deleted.');
            window.location.href = '/';
        }
    } catch (error) {
        deleteButton.innerHTML = `Delete`;
        deleteButton.setAttribute("disabled", true);
        devtricker_showToast(devtricker_createErrorToast('top', 10, error.message), "deleteAccountModal");
    }
}